import { Button, Modal } from 'antd'
import React, { useState } from 'react'
import amaliy1 from '../Components/fayl/amaliy/1.pdf'
import amaliy2 from '../Components/fayl/amaliy/2.pdf'
import amaliy3 from '../Components/fayl/amaliy/3.pdf'
import amaliy4 from '../Components/fayl/amaliy/4.pdf'
import amaliy5 from '../Components/fayl/amaliy/5.pdf'
import amaliy6 from '../Components/fayl/amaliy/6.pdf'
import amaliy7 from '../Components/fayl/amaliy/7.pdf'
import amaliy8 from '../Components/fayl/amaliy/8.pdf'
import amaliy9 from '../Components/fayl/amaliy/9.pdf'
import amaliy10 from '../Components/fayl/amaliy/10.pdf'



export const Amaliy = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <div className="card " >
            <Button className='button' onClick={showModal}>
                Amaliy mashg'ulotlar
            </Button>
            <Modal
                className="custom-modal "
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}> <br /> <hr />
                <div className='button-container'>
                    <Button className='button'>
                        <a href={amaliy1}>1-amaliy mashg'ulot</a>
                    </Button>
                    <Button className='button'>
                        <a href={amaliy2}>2-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy3}>3-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy4}>4-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy5}>5-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy6}>6-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy7}>7-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy8}>8-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy9}>9-amaliy mashg'ulot</a>
                    </Button><Button className='button'>
                        <a href={amaliy10}>10-amaliy mashg'ulot</a>
                    </Button>
                </div> <hr /><br />
            </Modal>
        </div>
    )
}
